import { render } from "./PetTherapeuticDevice.vue?vue&type=template&id=4aad486f&scoped=true"
import script from "./PetTherapeuticDevice.vue?vue&type=script&lang=js"
export * from "./PetTherapeuticDevice.vue?vue&type=script&lang=js"

import "./PetTherapeuticDevice.vue?vue&type=style&index=0&id=4aad486f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aad486f"]])

export default __exports__